// extracted by mini-css-extract-plugin
export var searchDrawer = "project-search-module--searchDrawer--3iCUE";
export var input = "project-search-module--input--2ZzPX";
export var results = "project-search-module--results--zc-j7";
export var projectLink = "project-search-module--projectLink--3xdKu";